import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WalletMainTable = _resolveComponent("WalletMainTable")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('header'))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('header-start'))
      }, [
        _createElementVNode("h2", {
          class: _normalizeClass(_ctx.b('title'))
        }, _toDisplayString(_ctx.$t("Мои активы")), 3),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('tabs'))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedTabs, (tab) => {
            return (_openBlock(), _createElementBlock("button", {
              class: _normalizeClass(_ctx.b('tab', { active: tab.active })),
              key: tab.id,
              onClick: ($event: any) => (_ctx.handleTab(tab.value))
            }, _toDisplayString(_ctx.$t(tab.label)), 11, _hoisted_1))
          }), 128))
        ], 2)
      ], 2),
      _createElementVNode("button", {
        class: _normalizeClass(_ctx.b('statement')),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleStatement && _ctx.handleStatement(...args)))
      }, _toDisplayString(_ctx.$t("Выписка")), 3)
    ], 2),
    _createVNode(_component_WalletMainTable, {
      list: _ctx.list,
      "filter-key": _ctx.tab
    }, null, 8, ["list", "filter-key"])
  ], 2))
}